import React, { memo } from "react";
import PropTypes from "prop-types";

import styles from "./style.css";

export function MultiSelectComponent(props) {
  const { value, wrap = false } = props;
  return (
    <div
      className={`${styles.multiselect} ${wrap ? styles.multiselectwrap : ""}`}
    >
      {value &&
        value.map &&
        value.map((val) => {
          return (
            <span className={styles.chip} key={val}>
              {val.Name || val}
            </span>
          );
        })}
    </div>
  );
}

MultiSelectComponent.propTypes = {
  value: PropTypes.array,
  wrap: PropTypes.bool
};

export const MultiSelect = memo(MultiSelectComponent);
